import { IPackage } from "dto/IPackage";
import { createContext } from "react";

type IEventContext = {
    blockClick: boolean;
    setBlockClick: (value: boolean) => void;
    manager: IPackage | null;
    setManager: (pack: IPackage | null) => void
}

const EventContext = createContext<IEventContext>({
    blockClick: false,
    setBlockClick: () => {},
    manager: null,
    setManager: () => {}
})

export default EventContext;